import * as actions from '../customize/actions';
import { makeSegmentProductList } from '../utils/utils';
import { segmentBaseInfo, maxPoints, orderId } from './const';
import { segmentAnalytics as analytics } from '@hungryroot/segment';

export const analyticsMiddleware = (store) => (next) => (action) => {
  const curr_state = store.getState();
  let eventName = null;
  let analyticsObj = { ...segmentBaseInfo };
  switch (action.type) {
    case actions.OPEN_VOLUME_MODAL:
      eventName = 'Received Cubic Volume Warning';
      analyticsObj.volume_type = 'total';
      break;
    case actions.OPEN_COLD_VOLUME_MODAL:
      eventName = 'Received Cubic Volume Warning';
      analyticsObj.volume_type = 'cold';
      break;
    case actions.CANCEL_EDITS_SEGMENT_TRK:
      eventName = 'Discarded Order Updates';
      break;
  }
  if (eventName) {
    const promiseA = new Promise((resolve, reject) => {
      return resolve(analytics.track(eventName, analyticsObj));
    });
    promiseA
      .then((_) => {
        if (action.type === actions.CANCEL_EDITS_SEGMENT_TRK) {
          window.onbeforeunload = null;
          window.location.href = `/upcoming/${orderId}/`;
        }
      })
      .catch((error) => console.error(error));
  }
  next(action);
};
